import { useCallback, useEffect } from 'react';
import { getUrnByViewerUrn } from '../models/modelManagement';
export function useSelectManagement({
  geometryLoaded,
  viewer,
  selectElements,
  invertedExternalIdMap,
  onSelectElements
}) {
  const selectModelElements = useCallback(params => {
    const {
      viewer,
      geometryLoaded,
      selectElements
    } = params;
    const isSelected = viewer.getSelectionCount();

    if (isSelected) {
      viewer.clearSelection();
      viewer.isolate();
    }

    const models = viewer.getVisibleModels();
    Object.entries(selectElements).forEach(([urn, externalIds]) => {
      const model = models.find(model => getUrnByViewerUrn(model.getData().urn) === urn);

      if (!geometryLoaded[urn] || !model) {
        return;
      }

      const objectIds = externalIds.map(extId => geometryLoaded[urn][extId]);
      objectIds.forEach(objectId => {
        viewer.toggleSelect(objectId, model, Autodesk.Viewing.SelectionMode.OVERLAYED);
      });
    });
  }, []);
  const selectionChanged = useCallback(e => {
    onSelectElements === null || onSelectElements === void 0 ? void 0 : onSelectElements(e.selections.reduce((acc, {
      dbIdArray,
      model
    }) => {
      const modelData = model.getData();
      const realUrn = getUrnByViewerUrn(modelData.urn);

      if (!realUrn || !invertedExternalIdMap[realUrn]) {
        return acc;
      }

      return { ...acc,
        [realUrn]: dbIdArray.map(objId => invertedExternalIdMap[realUrn][objId])
      };
    }, {}));
  }, [invertedExternalIdMap, onSelectElements]);
  useEffect(() => {
    if (viewer) {
      viewer.addEventListener(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, selectionChanged);
    }

    return () => {
      viewer === null || viewer === void 0 ? void 0 : viewer.removeEventListener(Autodesk.Viewing.AGGREGATE_SELECTION_CHANGED_EVENT, selectionChanged);
    };
  }, [selectionChanged, viewer]);
  useEffect(() => {
    if (viewer && selectElements && geometryLoaded) {
      selectModelElements({
        viewer,
        selectElements,
        geometryLoaded
      });
    }
  }, [viewer, geometryLoaded, selectElements, selectModelElements]);
}